import React, { useState } from "react";
import { BlankString, BTN_SMALL_LOADER, HTTPStatusCodes } from "../../Constants";
import PageTitle from "../../shared/PageTitle";
import Loader from "../../shared/Loader";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PostData } from "../../helpers/Fetch";

export default function ForgotPassword() {
  const [formDetails, setFormDetails] = useState<{ email: string, emailError: string, hasError: boolean, message: string }>({
    email: BlankString,
    emailError: BlankString,
    hasError: false,
    message: BlankString
  });
  const [showSpinner, setShowSpinner] = useState(false);
  const navigate = useNavigate();

  function ChangeHandler(event: any) {
    setFormDetails({ ...formDetails, [event.target.name]: event.target.value });
  };

  function ValidateEmailAndGetAccessCode(event: any) {
    event.preventDefault();
    setFormDetails({
      ...formDetails,
      hasError: false,
      message: BlankString
    });
    if (!formDetails.email) {
      setFormDetails({
        ...formDetails,
        hasError: true,
        message: "Please provide your registered email id"
      });
      return;
    };
    setShowSpinner(true);
    PostData(BlankString, `Security/GetAccessCode?email=${formDetails.email}`).then((response) => {
      setShowSpinner(false);
      if (response.statusCode === HTTPStatusCodes.InternalServerError || response.statusCode === undefined) {
        setFormDetails({
          ...formDetails,
          hasError: true,
          message: response.statusCode === HTTPStatusCodes.InternalServerError ? response.data.error.error_message : response.errorMessage
        });
      };
      if (response.statusCode === HTTPStatusCodes.BadRequest) {
        setFormDetails({
          ...formDetails,
          hasError: true,
          message: response.data.errorMessage
        });
      };
      if (response.statusCode === HTTPStatusCodes.OK) {
        navigate("/ForgotPassword/Reset", { state: { accessCode: true } });
      };
    });
  };

  return (
    <>
      <PageTitle title="Forgot Password" />
      <div className="container gp-container">
        <form noValidate>
          <div className="row">
            <div className="col-md-4">
              <div className={!formDetails.hasError ? "display-none" : "alert alert-danger"}>{formDetails.message}</div>
              <p className="input-info">
                <label className={formDetails.email !== BlankString ? "display-none" : BlankString}>Your Registered Email Id</label>
                <label className={formDetails.emailError === BlankString ? "display-none" : "error"}>{formDetails.emailError}</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Registered Email Id"
                  onChange={ChangeHandler}
                  value={formDetails.email}
                  autoComplete="false"
                  className={formDetails.emailError !== BlankString ? "input-validation-error" : "error"} />
              </p>
              <div>
                <button type="submit" className="btn-sm btn-small" onClick={ValidateEmailAndGetAccessCode} disabled={showSpinner}>
                  Get Access Code
                </button>
                <Loader size={BTN_SMALL_LOADER} loading={showSpinner} />
              </div>
              <div className="top-margin-5" style={{ marginBottom: 10 }}>
                <Link to="/Login" style={{ color: "#0000ff", fontSize: 15 }}>Back To Login Page</Link>
              </div>
            </div>
            <div className="col-md-8">
              <h2>Instructions</h2> 
              <br/>
              <p className="free-text">Please provide your email id registered with <span style={{ color: "#e5a529" }}>Golden Phoenix</span> to get access code.</p>
              
              <p className="free-text">If provided email id is valid and registered with us you will receive an access code in email which you can use to reset your password in next auto navigated screen.</p>
              
              <p className="free-text"><strong>Access code will be valid for 10 mins OR one time use, which ever occurs first.</strong></p>
              
              <p className="free-text">For any further assitance please send email to <a href="mailto:aportal@gpfalliance.com" style={{ color: "#e5a529" }}>aportal@gpfalliance.com</a>.</p>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};